export default "__VITE_ASSET__DDqs1ZhK__"